import { render, staticRenderFns } from "./UpdateCurrency.vue?vue&type=template&id=408562d0"
import script from "./UpdateCurrency.vue?vue&type=script&lang=js"
export * from "./UpdateCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports